export const baseURL = 'https://www.ufo-meble.pl:4000/'
export const proformaEmail = 'proformy@ufo-meble.pl'
export const developerMode = false;
